import { Injectable } from '@angular/core';
import { Cidade } from '@tivic-team/manager-ts/dist/grl';
import { CidadeController } from 'app/controllers/grl/cidade.controller';
import { LoaderService } from '../loader.service';
import { CidadeSearch } from './cidade.search';

@Injectable()
export class CidadeService {

    constructor(
        private _cidadeController:CidadeController,
        private _loaderService:LoaderService,
    ) { }

    async find(cidadeSearch?:CidadeSearch):Promise<Cidade[]>{
        try{return await this._cidadeController.find(cidadeSearch && cidadeSearch.getFilters() || null);}
        catch(error){console.log(error); return [];}
    }

    async get(cdCidade:number):Promise<any>{
        this._loaderService.show();
        return this._cidadeController.get(cdCidade).finally(() => this._loaderService.hide());
    }

    async save(cidade: Cidade): Promise<Cidade> {
        console.log('Loading Cidade Service...');
        this._loaderService.show();
        if(cidade.cdCidade && cidade.cdCidade > 0){
            console.log('Update');
            return this._cidadeController.update(cidade).finally(() => this._loaderService.hide());
        } else {
            console.log('Create');
            return this._cidadeController.create(cidade).finally(() => this._loaderService.hide());
        }
    }
    
}